import React, { useEffect, useState, useRef } from "react"
import {
    getDidMagentoApi,
    addDidMagentoApi,
    deleteDidMagentoApi,
} from "../../../../utilities/api/phoenix-api"
import {
    Flex,
    lightTheme,
    Provider,
    SearchField,
    ActionGroup,
    Item,
    Text,
    Content,
    IllustratedMessage,
    Heading,
    TableView,
    TableHeader,
    Column,
    TableBody,
    Cell,
    Row,
    ProgressCircle,
} from "@adobe/react-spectrum"
import Delete from "@spectrum-icons/workflow/Delete"
import Draw from "@spectrum-icons/workflow/Draw"
import { PheonixRoles, notify } from "../../../../constants/constants"
import { connect } from "react-redux"
import AddDidMagento from "./AddDidMagento"
import { renderEmptyState } from "../../../../utilities/components/CommonUseComponents"

function mapStateToProps(state) {
    return {
        user: state.login.userInfo,
        permissions:
            state.login.authorizedAccess != null
                ? state.login.authorizedAccess.permissions
                : [],
        rolesAndPermissions: state.login.rolesAndPermissions,
    }
}

const DidMagento = ({ user, rolesAndPermissions }) => {
    const havingDeletePermission = rolesAndPermissions["AMAZON CONNECT"]?.delete?.filter((ele) => ele.subService === "ROUTING FLOW CONFIG:DID MAGENTO")[0]?.resources.groups
    const havingEditPermission = rolesAndPermissions["AMAZON CONNECT"]?.edit?.filter((ele) => ele.subService === "ROUTING FLOW CONFIG:DID MAGENTO")[0]?.resources.groups
    // const havingViewPermission = rolesAndPermissions["AMAZON CONNECT"]?.view?.filter((ele) => ele.subService === "ROUTING FLOW CONFIG:DID MAGENTO")[0]?.resources.groups
    const havingAddPermission = rolesAndPermissions["AMAZON CONNECT"]?.add?.filter((ele) => ele.subService === "ROUTING FLOW CONFIG:DID MAGENTO")[0]?.resources.groups

    const [magento, setMagento] = useState([])
    const [filteredMagento, setFilteredMagento] = useState([])
    // const [errorMessage, setErrorMessage] = useState("")
    const [currentText, setCurrentText] = useState(null)
    const [selectedMagento, setSelectedMagento] = useState(new Set())
    const [operation, setOperation] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    const [isAddDialogOpen, setIsAddDialogOpen] = useState(false)
    // const [isdeleteDialogOpen, setIsDeleteDialogOpen] = useState(false)
    const ldap = user?.userid
    // const isAdmin = props?.permissions?.includes(
    //     PheonixRoles.didMagentoAdmin
    // )

    // const columns = [
    //     { name: "DID", key: "did" },
    //     { name: "Ldap", key: "ldap" },
    // ]

    const columnsAdmin = [
        { name: "DID", key: "did" },
        { name: "Ldap", key: "ldap" },
        { name: "Actions", key: "actions" },
    ]

    // const currentTimeoutSelected = useRef("")
    const editData = useRef(false)

    const getAllDidMagento = () => {
        setIsLoading(true)
        getDidMagentoApi()
            .then((res) => {
                setMagento(res)
                setFilteredMagento(res)
                setIsLoading(false)
            })
            .catch(() => {
                console.log("Error in getting Did Magento")
            })
    }

    useEffect(() => {
        getAllDidMagento()
    }, [])

    const deleteDidMagento = (ldap, name, multi) => {
        if (multi === "multi") {
            setIsLoading(true)
            const formatedData = name.join()
            const urlencoded = new URLSearchParams()
            urlencoded.append("did", formatedData)
            deleteDidMagentoApi(ldap, urlencoded)
                .then((res) => {
                    notify(res, "success")
                    getAllDidMagento()
                    setSelectedMagento(new Set())
                    setIsLoading(false)
                })
                .catch(() => {
                    notify("Error in Multi deleting Did Magento")
                    setIsLoading(false)
                })
        } else {
            setIsLoading(true)
            const urlencoded = new URLSearchParams()
            urlencoded.append("did", name)
            deleteDidMagentoApi(ldap, urlencoded)
                .then((res) => {
                    notify(res, "success")
                    getAllDidMagento()
                    setIsLoading(false)
                })
                .catch(() => {
                    notify("Error in deleting Magento")
                    setIsLoading(false)
                })
        }
    }

    const performAction = (value, item) => {
        switch (value) {
            case "add":
                editData.current = null
                setIsAddDialogOpen(true)
                setOperation("Add")
                break
            case "edit":
                editData.current = magento.find((val) => val.did == item)
                setIsAddDialogOpen(true)
                setOperation("Edit")
                break
            case "delete":
                deleteDidMagento(ldap, item)
                // currentTimeoutSelected.current = item
                // setIsDeleteDialogOpen(true)
                break
            case "bulkDelete":
                const selectedOptions = Array.from(selectedMagento)
                deleteDidMagento(ldap, selectedOptions, "multi")
                // setIsDeleteDialogOpen(true)
                break
        }
    }

    const getCell = (columnKey, item) => {
        switch (columnKey) {
            case "actions":
                return (
                    <Cell>
                        <ActionGroup
                            onAction={(value) => performAction(value, item.did)}
                            disabledKeys={[
                                !havingEditPermission && "edit",
                                !havingDeletePermission && "delete",
                            ]}
                        >
                            <Item key="edit">
                                <Draw />
                            </Item>
                            <Item key="delete">
                                <Delete />
                            </Item>
                        </ActionGroup>
                    </Cell>
                )
            case "did":
                return <Cell>{item[columnKey]}</Cell>
            case "ldap":
                return <Cell>{item[columnKey]}</Cell>
            default:
                return <Cell>{item[columnKey]}</Cell>
        }
    }

    // const isDuplicateTimeoutName = (name) => {
    //     return timeOut.some((ele) => ele.timeoutName === name);
    // };

    const closeAddTimeOutDialog = (isAddConfirmed, body) => {
        // if(isDuplicateTimeoutName(timeoutName)){
        //     notify(`${timeoutName} already exist`,"error");
        //     return;
        // }
        setIsAddDialogOpen(false)
        if (isAddConfirmed) {
            setIsLoading(true)
            addDidMagentoApi(ldap, body)
                .then((res) => {
                    getAllDidMagento()
                    notify(res, "success")
                })
                .catch(() => notify("Error in Adding Did Magento", "error"))

            setIsLoading(false)
        }
    }

    const filterDidMagentoList = (value) => {
        if (value === "") {
            setFilteredMagento(magento)
        } else {
            const getFilteredData = filteredMagento.filter((val) =>
                val.did.toString().includes(value.toString())
            )
            setFilteredMagento(getFilteredData)
        }
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            if (currentText !== null) {
                filterDidMagentoList(currentText)
            }
        }, 500)
        return () => clearTimeout(timer)
    }, [currentText])

    const searchDidMagento = (value) => {
        setCurrentText(value)
    }

    return (
        <>
            {isLoading ? (
                <div
                    className={isLoading ? "display-block" : "display-none"}
                    style={{
                        paddingTop: "10%",
                        paddingLeft: "45%",
                        position: "absolute",
                        zIndex: "10",
                    }}
                >
                    <ProgressCircle
                        aria-label="Loading…"
                        isIndeterminate
                        size="L"
                    />
                </div>
            ) : null}

            <div align="center">
                <Heading variant="pageTitle">DID MAGENTO</Heading>
            </div>

            <div
                style={{
                    padding: "25px",
                    border: "0.8px solid",
                    borderRadius: "0.7em",
                    marginTop: "30px",
                    width: "56vw",
                    margin: "0 auto",
                }}
            >
                <Provider theme={lightTheme}>
                    <Flex
                        direction="row"
                        gap="size-100"
                        UNSAFE_className="searchMobile"
                    >
                        <SearchField
                            aria-label="search"
                            value={currentText}
                            onChange={searchDidMagento}
                            isQuiet
                            onClear={() => setCurrentText("")}
                            width={"30%"}
                        />

                        {
                            <ActionGroup
                                width={"80%"}
                                alignItems="end"
                                onAction={(value) => performAction(value, null)}
                                disabledKeys={[!havingAddPermission && "add", !havingDeletePermission && "bulkDelete",]}
                                   
                                    // selectedMagento.size ||
                                    // selectedMagento == "all"
                                    //     ? []
                                    //     : ["bulkDelete"]
                                // }
                            >
                                <Item key="add">+ Add</Item>
                                <Item key="bulkDelete">
                                    <Delete />
                                    <Text>Delete</Text>
                                </Item>
                            </ActionGroup>
                        }
                    </Flex>

                    <Flex
                        width="100%"
                        height="100%"
                        direction="column"
                        gap="size-150"
                    >
                        <TableView
                            aria-label="Timeout"
                            selectionMode={!havingDeletePermission ? "none" : "multiple"}
                            selectedKeys={selectedMagento}
                            onSelectionChange={setSelectedMagento}
                            height={"45vh"}
                            renderEmptyState={renderEmptyState}
                            density="spacious"
                            overflowMode="wrap"
                            // disabledKeys={!havingDeletePermission ? [] : filteredMagento.map(item => item.did)}
                        >
                            <TableHeader
                                columns={columnsAdmin}
                            >
                                {(column) => (
                                    <Column
                                        key={column.key}
                                        align={
                                            column.key === "actions"
                                                ? "end"
                                                : "start"
                                        }
                                        // width={column.key === "timeoutName" ? "50%" : column.key === "actions" ? "23%" : "auto"}
                                    >
                                        {column.name}
                                    </Column>
                                )}
                            </TableHeader>
                            <TableBody items={filteredMagento}>
                                {(item) => (
                                    <Row key={item.did}>
                                        {(columnKey) =>
                                            getCell(columnKey, item)
                                        }
                                    </Row>
                                )}
                            </TableBody>
                        </TableView>
                    </Flex>
                </Provider>

                {isAddDialogOpen && (
                    <AddDidMagento
                        isDialogOpened={isAddDialogOpen}
                        editData={editData.current}
                        operation={operation}
                        handleCloseDialog={(isAddConfirmed, body) =>
                            closeAddTimeOutDialog(isAddConfirmed, body)
                        }
                    />
                )}
            </div>
        </>
    )
}

export default connect(mapStateToProps)(DidMagento)
